/* eslint-disable @typescript-eslint/no-empty-function */
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild, } from '@angular/core';
import { provideValueAccessor } from '@mhe/ngx-shared/utils';
import { InputType } from './input-type';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "@mhe/ngx-shared/required-indicator";
const _c0 = ["input"];
function InputComponent_label_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label");
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "mhe-required-indicator", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("disabled", ctx_r0.disabled ? "disabled" : null);
    i0.ɵɵattribute("for", ctx_r0.id);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.label, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("required", ctx_r0.required);
} }
function InputComponent_i_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 7);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("ngClass", ctx_r2.icon ? "dpg-icon-" + ctx_r2.icon : "");
} }
function InputComponent_span_5_i_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 12);
} }
function InputComponent_span_5_i_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 13);
} }
function InputComponent_span_5_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const message_r7 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(message_r7);
} }
function InputComponent_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8);
    i0.ɵɵtemplate(1, InputComponent_span_5_i_1_Template, 1, 0, "i", 9);
    i0.ɵɵtemplate(2, InputComponent_span_5_i_2_Template, 1, 0, "i", 10);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtemplate(4, InputComponent_span_5_span_4_Template, 3, 1, "span", 11);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵattribute("id", ctx_r3.helpBlockId);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.error);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.success);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r3.feedback);
} }
/**
 * @deprecated since version 9.0
 */
export class InputComponent {
    constructor(_changeDetectorRef, _renderer) {
        this._changeDetectorRef = _changeDetectorRef;
        this._renderer = _renderer;
        this.disabled = null;
        this.error = false;
        this.feedback = [];
        this.id = null;
        this.maxlength = null;
        this.placeholder = null;
        this.success = false;
        this.type = InputType.Text;
        this.icon = '';
        this.inputAttributes = {};
        this.required = false;
        this.providedValue = null;
        this.inputChange = new EventEmitter();
        this.inputFocus = new EventEmitter();
        this.inputBlur = new EventEmitter();
        this.onChange = (_) => { };
        this.onTouch = (event) => {
            this.inputFocus.emit({
                event,
                componentInstance: this,
            });
        };
    }
    get value() {
        return this.providedValue;
    }
    set value(value) {
        if (this.value !== value) {
            this.providedValue = value;
        }
    }
    get hasFeedback() {
        return this.success || this.error;
    }
    get isInvalid() {
        if (this.success || this.error) {
            return this.success ? 'false' : 'true';
        }
        return undefined;
    }
    get hasIcon() {
        return this.icon !== '';
    }
    get helpBlockId() {
        return `help-block-${this.id}`;
    }
    get inputDescribedBy() {
        if (this.hasFeedback) {
            return this.helpBlockId;
        }
        return undefined;
    }
    ngOnChanges(changes) {
        const { inputAttributes } = changes;
        if (inputAttributes) {
            this.updateAttributes(inputAttributes);
        }
    }
    onInput(event, value) {
        this.inputChange.emit({ event, value });
        this.onChange(value);
    }
    onBlur(event, value) {
        this.inputBlur.emit({ event, value });
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
        this._changeDetectorRef.markForCheck();
    }
    updateAttributes(inputAttributes) {
        const { currentValue, firstChange, previousValue } = inputAttributes;
        if (!firstChange && previousValue) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            Object.entries(previousValue).forEach(([key]) => {
                this._renderer.removeAttribute(this.inputElRef.nativeElement, `${key}`);
            });
        }
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        Object.entries(currentValue).forEach(([key, value]) => {
            this._renderer.setAttribute(this.inputElRef.nativeElement, `${key}`, `${value}`);
        });
    }
    writeValue(val) {
        if (val !== this.value) {
            const normalizedValue = val == null ? '' : val;
            this.value = normalizedValue;
            this._changeDetectorRef.markForCheck();
        }
    }
}
InputComponent.ɵfac = function InputComponent_Factory(t) { return new (t || InputComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.Renderer2)); };
InputComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: InputComponent, selectors: [["mhe-input"]], viewQuery: function InputComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 7);
        i0.ɵɵviewQuery(_c0, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputEl = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputElRef = _t.first);
    } }, inputs: { disabled: "disabled", error: "error", feedback: "feedback", id: "id", label: "label", maxlength: "maxlength", placeholder: "placeholder", success: "success", type: "type", icon: "icon", inputAttributes: "inputAttributes", required: "required", value: "value" }, outputs: { inputChange: "inputChange", inputFocus: "inputFocus", inputBlur: "inputBlur" }, features: [i0.ɵɵProvidersFeature([provideValueAccessor(InputComponent)]), i0.ɵɵNgOnChangesFeature], decls: 6, vars: 19, consts: [[1, "ahe-ui", "form-group"], [3, "disabled", 4, "ngIf"], [1, "form-control", 3, "ngClass", "type", "value", "focus", "blur", "input"], ["input", ""], ["class", "dpg-icon", "aria-hidden", "true", 3, "ngClass", 4, "ngIf"], ["class", "help-block", "aria-live", "assertive", 4, "ngIf"], [3, "required"], ["aria-hidden", "true", 1, "dpg-icon", 3, "ngClass"], ["aria-live", "assertive", 1, "help-block"], ["class", "dpg-icon dpg-icon-incorrect", "aria-hidden", "true", 4, "ngIf"], ["class", "dpg-icon dpg-icon-input-success", "aria-hidden", "true", 4, "ngIf"], [4, "ngFor", "ngForOf"], ["aria-hidden", "true", 1, "dpg-icon", "dpg-icon-incorrect"], ["aria-hidden", "true", 1, "dpg-icon", "dpg-icon-input-success"]], template: function InputComponent_Template(rf, ctx) { if (rf & 1) {
        const _r8 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, InputComponent_label_1_Template, 3, 5, "label", 1);
        i0.ɵɵelementStart(2, "input", 2, 3);
        i0.ɵɵlistener("focus", function InputComponent_Template_input_focus_2_listener($event) { return ctx.onTouch($event); })("blur", function InputComponent_Template_input_blur_2_listener($event) { i0.ɵɵrestoreView(_r8); const _r1 = i0.ɵɵreference(3); return i0.ɵɵresetView(ctx.onBlur($event, _r1.value)); })("input", function InputComponent_Template_input_input_2_listener($event) { i0.ɵɵrestoreView(_r8); const _r1 = i0.ɵɵreference(3); return i0.ɵɵresetView(ctx.onInput($event, _r1.value)); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, InputComponent_i_4_Template, 1, 1, "i", 4);
        i0.ɵɵtemplate(5, InputComponent_span_5_Template, 5, 4, "span", 5);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵclassProp("has-feedback", ctx.hasFeedback)("has-success", ctx.success)("has-error", ctx.error);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.label);
        i0.ɵɵadvance(1);
        i0.ɵɵpropertyInterpolate("ngClass", ctx.icon ? "has-icon" : "");
        i0.ɵɵproperty("type", ctx.type)("value", ctx.value);
        i0.ɵɵattribute("disabled", ctx.disabled ? "" : null)("id", ctx.id)("maxlength", ctx.maxlength)("placeholder", ctx.placeholder)("aria-describedby", ctx.inputDescribedBy)("aria-invalid", ctx.isInvalid)("required", ctx.required ? "" : null);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.icon);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.hasFeedback);
    } }, dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i2.RequiredIndicatorComponent], styles: ["\n"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InputComponent, [{
        type: Component,
        args: [{ selector: 'mhe-input', changeDetection: ChangeDetectionStrategy.OnPush, providers: [provideValueAccessor(InputComponent)], template: "<div\n  class=\"ahe-ui form-group\"\n  [class.has-feedback]=\"hasFeedback\"\n  [class.has-success]=\"success\"\n  [class.has-error]=\"error\"\n>\n  <label *ngIf=\"label\" [attr.for]=\"id\" [class.disabled]=\"disabled ? 'disabled' : null\">\n    {{ label }}<mhe-required-indicator [required]=\"required\"></mhe-required-indicator>\n  </label>\n\n  <input\n    #input\n    class=\"form-control\"\n    ngClass=\"{{ icon ? 'has-icon' : '' }}\"\n    [type]=\"type\"\n    [attr.disabled]=\"disabled ? '' : null\"\n    [attr.id]=\"id\"\n    [attr.maxlength]=\"maxlength\"\n    [attr.placeholder]=\"placeholder\"\n    [value]=\"value\"\n    (focus)=\"onTouch($event)\"\n    (blur)=\"onBlur($event, input.value)\"\n    (input)=\"onInput($event, input.value)\"\n    [attr.aria-describedby]=\"inputDescribedBy\"\n    [attr.aria-invalid]=\"isInvalid\"\n    [attr.required]=\"required ? '' : null\"\n  />\n  <i *ngIf=\"icon\" class=\"dpg-icon\" ngClass=\"{{ icon ? 'dpg-icon-' + icon : '' }}\" aria-hidden=\"true\"></i>\n\n  <span *ngIf=\"hasFeedback\" class=\"help-block\" [attr.id]=\"helpBlockId\" aria-live=\"assertive\">\n    <i *ngIf=\"error\" class=\"dpg-icon dpg-icon-incorrect\" aria-hidden=\"true\"></i>\n    <i *ngIf=\"success\" class=\"dpg-icon dpg-icon-input-success\" aria-hidden=\"true\"></i>\n    <span>\n      <span *ngFor=\"let message of feedback\">{{ message }}<br /></span>\n    </span>\n  </span>\n</div>\n", styles: ["/*# sourceMappingURL=input.component.css.map */\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }]; }, { disabled: [{
            type: Input
        }], error: [{
            type: Input
        }], feedback: [{
            type: Input
        }], id: [{
            type: Input
        }], label: [{
            type: Input
        }], maxlength: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], success: [{
            type: Input
        }], type: [{
            type: Input
        }], icon: [{
            type: Input
        }], inputAttributes: [{
            type: Input
        }], required: [{
            type: Input
        }], value: [{
            type: Input
        }], inputChange: [{
            type: Output
        }], inputFocus: [{
            type: Output
        }], inputBlur: [{
            type: Output
        }], inputEl: [{
            type: ViewChild,
            args: ['input', { static: true }]
        }], inputElRef: [{
            type: ViewChild,
            args: ['input', { static: true }]
        }] }); })();
